<div
  (clickOutside)="isOpen.set(false)"
  [ngClass]="{ block: displayAsBlock(), 'inline-block': !displayAsBlock() }"
  class="relative">
  <div
    (click)="toggleSelect()"
    (keydown)="onKeydown($event)"
    [class.border-gray]="disabled()"
    [class.cursor-pointer]="!disabled() && hasMultipleOptions()"
    [class.pointer-events-none]="disabled()"
    [class.rounded-t-xl]="isOpen()"
    [class.rounded-xl]="!isOpen()"
    class="flex h-11 justify-between gap-x-3 border p-3"
    role="button"
    tabindex="0">
    <span class="flex w-full flex-1 justify-start">
      @if (selected(); as selected) {
        {{ selected.label }}
      } @else {
        {{ placeholder() }}
      }
    </span>
    @if (hasMultipleOptions()) {
      <app-svg
        [class.text-gray]="disabled()"
        [height]="15"
        [inline]="true"
        [width]="7"
        class="rotate-90"
        src="assets/icons/caret-right.svg" />
    }
  </div>
  @if (isOpen() && hasMultipleOptions()) {
    <div
      [ngClass]="{
        'left-1/2 -translate-x-1/2': dropdownPosition() === 'CENTER',
        'right-0': dropdownPosition() === 'RIGHT',
      }"
      class="absolute z-50 -mt-px w-max min-w-full overflow-hidden rounded-b-xl border bg-gray-light">
      <ul class="flex max-h-[258px] flex-col overflow-y-auto desk:max-h-[344px]">
        @for (option of options(); track option.key) {
          @if (option.key != selected()?.key) {
            <li (click)="select(option)" class="cursor-pointer p-3 last:rounded-b-xl hover:bg-gray/25">
              {{ option.label }}
            </li>
          }
        }
      </ul>
    </div>
  }
</div>
